import http from 'hub-http/clients/noAuthApiClient';
import { registerQuery, useQuery } from 'data-fetching-client';
import { emptySearchResponse, geolocationsPath } from '../../consts';
import { useCallback, useMemo, useRef } from 'react';
import uniqBy from 'hs-lodash/uniqBy';
const GET_GEOLOCATIONS = registerQuery({
  fieldName: 'geolocations',
  args: ['offset', 'count', 'query'],

  fetcher({
    offset,
    count,
    query
  }) {
    return http.get(`${geolocationsPath}/search`, {
      query: Object.assign({
        offset,
        count
      }, query && {
        query
      })
    });
  }

});
export const createGeoocationEntry = geolocation => {
  return http.post(geolocationsPath, {
    data: geolocation
  });
};
export const useGeolocations = () => {
  const cumulativeLocations = useRef([]);
  const {
    data,
    error: geolocationsError,
    loading: geolocationsLoading,
    fetchMore
  } = useQuery(GET_GEOLOCATIONS, {
    variables: {
      offset: 0,
      count: 50,
      query: ''
    }
  });
  const geolocations = useMemo(() => data ? data.geolocations : emptySearchResponse, [data]);
  const getGeolocations = useCallback((query, offset) => {
    return fetchMore({
      variables: {
        query,
        offset,
        count: 50
      }
    }).then(response => {
      if (query) {
        return response.data.geolocations;
      }

      const cumulativeResults = uniqBy([...cumulativeLocations.current, ...response.data.geolocations.results], location => location.id);
      cumulativeLocations.current = cumulativeResults;
      return Object.assign({}, response.data.geolocations, {
        results: cumulativeResults
      });
    });
  }, [fetchMore, cumulativeLocations]);
  return {
    geolocations,
    geolocationsError,
    geolocationsLoading,
    getGeolocations
  };
};